<template>
  <main class="p-mailaddresschangecomplete l-page">
    <section class="p-mailaddresschangecomplete__wrap">
      <h2 class="c-regist__title">{{ t('MailAddressChangeCompletePage.title') }}</h2>
      <p class="c-regist__comment message">{{ t('MailAddressChangeCompletePage.message') }}</p>
      <div class="p-complete__line-link">
        <a class="c-button" :href="fluxLoginUrl">
          <span class="c-button__text">{{ t('CompletePage.login') }}</span>
        </a>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import AppInfo from '@/util/AppInfo'
import { computed, defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import useValidateForAccess from '@/Hooks/useValidateForAccess'

export default defineComponent({
  name: 'MailAddressChangeCompletePage',
  setup() {
    const { t } = useI18n()
    onMounted(() => {
      useValidateForAccess('MailAddressChangeStore', ['tokenId'], 'ErrorPage')
    })
    const fluxLoginUrl = computed(() => {
      const appType = AppInfo.isSmartPhone ? 'flsp' : 'fl'
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/${appType}/index.html#/login`
    })
    return {
      t,
      fluxLoginUrl,
    }
  },
  components: {},
})
</script>

<style scoped lang="scss"></style>
